import { create } from "zustand";

type State = {
  showProviderModal: boolean;
  scroll: boolean;
};

type Actions = {
  setShowProviderModal: (value: boolean) => void;
  setScroll: (value: boolean) => void;

  setShowChainSwitchWarningModal: (value: boolean) => void;
  showChainSwitchWarningModal: boolean;

  setShowClaimWaitingModal: (value: boolean) => void;
  showClaimWaitingModal: boolean;

  setShowWithdrawWaitingModal: (value: boolean) => void;
  showWithdrawWaitingModal: boolean;

  setShowStakeWaitingModal: (value: boolean) => void;
  showStakeWaitingModal: boolean;

  setShowUnStakeWaitingModal: (value: boolean) => void;
  showUnStakeWaitingModal: boolean;

  setShowClaimSuccessModal: (value: boolean) => void;
  showClaimSuccessModal: boolean;

  setShowWithdrawSuccessModal: (value: boolean) => void;
  showWithdrawSuccessModal: boolean;

  setShowStakeSuccessModal: (value: boolean) => void;
  showStakeSuccessModal: boolean;

  setShowUnStakeSuccessModal: (value: boolean) => void;
  showUnStakeSuccessModal: boolean;

  setShowStakeModal: (value: boolean) => void;
  showStakeModal: boolean;

  setShowUnStakeModal: (value: boolean) => void;
  showUnStakeModal: boolean;

  setTxError: (value: string) => void;
  txError: string;

  setDashboardReload: (value: boolean) => void;
  dashboardReload: boolean;
};

export const useModalStore = create<State & Actions>((set) => ({
  showProviderModal: false,
  setShowProviderModal: (value) => {
    set({ showProviderModal: value });
  },
  scroll: false,
  setScroll: (value) => {
    set({ scroll: value });
  },

  showChainSwitchWarningModal: false,
  setShowChainSwitchWarningModal: (value) => {
    set({ showChainSwitchWarningModal: value });
  },

  showClaimWaitingModal: false,
  setShowClaimWaitingModal: (value) => {
    set({ showClaimWaitingModal: value });
  },

  showWithdrawWaitingModal: false,
  setShowWithdrawWaitingModal: (value) => {
    set({ showWithdrawWaitingModal: value });
  },

  showStakeWaitingModal: false,
  setShowStakeWaitingModal: (value) => {
    set({ showStakeWaitingModal: value });
  },

  showUnStakeWaitingModal: false,
  setShowUnStakeWaitingModal: (value) => {
    set({ showUnStakeWaitingModal: value });
  },

  showClaimSuccessModal: false,
  setShowClaimSuccessModal: (value) => {
    set({ showClaimSuccessModal: value });
  },

  showWithdrawSuccessModal: false,
  setShowWithdrawSuccessModal: (value) => {
    set({ showWithdrawSuccessModal: value });
  },

  showStakeSuccessModal: false,
  setShowStakeSuccessModal: (value) => {
    set({ showStakeSuccessModal: value });
  },

  showUnStakeSuccessModal: false,
  setShowUnStakeSuccessModal: (value) => {
    set({ showUnStakeSuccessModal: value });
  },

  showStakeModal: false,
  setShowStakeModal: (value) => {
    set({ showStakeModal: value });
  },

  showUnStakeModal: false,
  setShowUnStakeModal: (value) => {
    set({ showUnStakeModal: value });
  },

  txError: "",
  setTxError: (value) => {
    set({ txError: value });
  },

  dashboardReload: false,
  setDashboardReload: (value) => {
    set((state) => ({ dashboardReload: !state.dashboardReload }));
  },
}));
